export default __webpack_public_path__ + "fff3ddc2b0e0f700c315cf46861b024d.svg";